import AppConstants from "../../../Constants/AppConstants";
import { _functionHelper } from "../HelperFunction/HelperFunction";
const forFeedBack = (_value, isEquipmentNio) => {
  if ("bothioandnio" === _value.toLowerCase()) {
    return true;
  } else if ("onlynio" === _value.toLowerCase()) {
    if (isEquipmentNio) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
export const ConstructInspectionObject = (
  checkList,
  checkListTitle,
  feedBack,
  equipmentDetails,
  photoNeeded,
  inspectionImage,
  uniqueClientId,
  isEquipmentNio,
  startDate,
  ticketTitle,
  ticketDescription,
  ticketCategory,
  ticketPriority,
  language
) => {
  const date = new Date();
  let _tempQuestion = [];
  const _templock = [...checkList];
  let ticketQuestions = [];
  _templock.forEach((chapter) => {
    chapter["checklistBlockModels"].forEach((block) => {
      block["pruefFragenItemModels"].forEach((ques) => {
        const isHasSecondValue = _functionHelper.isQueType(ques.answerType);
        const _tempPayload = {
          ID: AppConstants.DEFAULT_GUID,
          AuftragID: ques.id,
          QuestionId: ques.id,
          Frage: ques.frage,
          Antwort: isHasSecondValue
            ? ques["value"]["first"].trim()
            : ques["value"]
            ? ques["value"].trim()
            : "",
          Position: ques.position,
          lfdNr: ques.lfdNr,
          ChecklistId: ques["checklistId"],
          ChecklistBlockId: block["id"],
          AnswerType: ques.answerType,
        };
        if (isHasSecondValue) {
          _tempPayload.ShouldTakeEquipmentOutOfOrder =
            ques["value"]["second"] === "yes" ? true : false;
        }
        // Include optional question image if provided
        if (ques.questionImage) {
          _tempPayload["QuestionImage"] = [ques.questionImage];
        }
        _tempQuestion.push({ ..._tempPayload });
        if (ques.canCreateTicket && ques.createTicket) {
          ticketQuestions.push({
            Frage: ques.frage,
            Antwort: isHasSecondValue ? ques.value.first : ques.value,
          });
        }
      });
    });
  });

  const inspectionObject = {
    ChecklistId: checkList[0]["checklistId"],
    AnlageId: equipmentDetails["anlageID"],
    //  BenutzerId: sessionStorage.getItem("userId"),
    AuftragsNr: "",
    StartDatum: startDate,
    EndDatum: date.toISOString(),
    Status: "BEEND",
    //   Beschreibung: checkListTitle,
    StatusDatum: date.toISOString(),
    Turnus: 0,
    TurnusZyklus: "",
    BestelltNr: null,
    Kurzbezeichnung: "",
    Rueckmeldungsstatus: false,
    Detailedfeedback:
      feedBack !== ""
        ? {
            ID: feedBack["id"],
            Beschreibung: feedBack["bezeichnung"],
          }
        : null,
    ZeitRueckmeldung: {},
    PruefFragenRueckmeldungs: _tempQuestion,
    AnlageAttributes: [],
    AuftragBilds: inspectionImage ? inspectionImage : [],
    ClientID: uniqueClientId,
    IsEqipmentNIO: isEquipmentNio,
    Ticket:
      ticketQuestions.length == 0
        ? null
        : {
            Id: null,
            TicketType: "Inspection",
            Title: ticketTitle,
            Description: ticketDescription,
            TicketReferenceId: equipmentDetails.anlageID
              ? equipmentDetails.anlageID.toString()
              : "",
            UserName: "",
            Password: "",
            AnlagegruppeId: AppConstants.DEFAULT_GUID,
            Priority: ticketPriority,
            Category: ticketCategory,
            Files: inspectionImage ? inspectionImage : [],
            Language: language,
            QuestionAnswer: ticketQuestions,
          },
  };

  return inspectionObject;
};
